import * as superagent from "superagent";
import {config} from "../../config";
import {Card} from "../Card";
import {CardFactory} from "../CardFactory";
import {CurrencyDenominator} from "../CurrencyDenominator";
import {InfoModal} from "../InfoModal";
import {ServerResponse} from "./serverResponseClasses/ServerResponse";
import {VideoPokerHand} from "./serverResponseClasses/VideoPokerHand";
import {VideoPokerInfoForClient} from "./serverResponseClasses/VideoPokerInfoForClient";
import {VideoPokerAction} from "./VideoPokerAction";

export class ApiService {

    private readonly STEEM_ACCOUNT_NAME: string = "steemAccountName";
    private readonly STEEM_CONNECT_TOKEN: string = "steemConnectToken";
    private readonly KEYCHAIN_JWT: string = "keychainjwt";

    private steemAccountName: string;
    private steemConnectToken: string;
    private keychainJWT: string;

    constructor() {
    }

    public setGameState(videoPokerAction: VideoPokerAction, betCurrency: string): Promise<ServerResponse> {
        if (videoPokerAction.betAmount) {
            videoPokerAction.betAmount = CurrencyDenominator.ToBase(videoPokerAction.betAmount);
        }

        return superagent
            .post(config.gameServerAddress + "/setGameState")
            .set(this.STEEM_ACCOUNT_NAME, this.steemAccountName)
            .set(this.STEEM_CONNECT_TOKEN, this.steemConnectToken)
            .set(this.KEYCHAIN_JWT, this.keychainJWT)
            .send({currencyType: betCurrency, videoPokerAction})
            .then((res): any => {
                return this.deserializeServerResponse(res.body.data);
            }).catch((res) => {
                if (res.status === 402) {
                    InfoModal.open("You need more Hive to keep playing.",
                        "Make a quick deposit and go back to the game!", () => {
                            if (top && top.window) {
                                top.window.location.replace(config.pageAddress);
                            } else {
                                window.location.replace(config.pageAddress);
                            }
                        });
                    InfoModal.setActionButtonText("GO TO MAKING DEPOSIT");
                } else if (res.status === 500) {
                    // window.location.reload(false);
                }
            });
    }

    public initGame(steemAccountName: string,
                    steemConnectToken: string,
                    keychainJWT: string): Promise<ServerResponse> {
        return superagent
            .get(config.gameServerAddress + "/initGame")
            .set(this.STEEM_ACCOUNT_NAME, steemAccountName)
            .set(this.STEEM_CONNECT_TOKEN, steemConnectToken)
            .set(this.KEYCHAIN_JWT, keychainJWT)
            .send({})
            .then((res) => {
                this.steemAccountName = steemAccountName;
                this.steemConnectToken = steemConnectToken;
                this.keychainJWT = keychainJWT;
                return this.deserializeServerResponse(res.body.data);
            });
    }

    private deserializeServerResponse(rawServerResponse: any): ServerResponse {
        rawServerResponse.accountInfo.steemAmount =
            CurrencyDenominator.ToMain(rawServerResponse.accountInfo.steemAmount);

        if (!rawServerResponse.videoPokerInfoForClient) {
            return new ServerResponse(rawServerResponse.accountInfo, null, rawServerResponse.sessionParam);
        }
        const rawVpHand: any = rawServerResponse.videoPokerInfoForClient.videoPokerHand;
        const videoPokerHand: VideoPokerHand = new VideoPokerHand();

        videoPokerHand.setCards(this.deserializeCardsArray(rawVpHand.cards));

        return new ServerResponse(rawServerResponse.accountInfo, new VideoPokerInfoForClient(
                videoPokerHand,
                rawServerResponse.videoPokerInfoForClient.changeDone,
                this.deserializeCardsArray(rawServerResponse.videoPokerInfoForClient.doubleUpCards),
                rawServerResponse.videoPokerInfoForClient.playerActionsFinished,
                CurrencyDenominator.ToMain(rawServerResponse.videoPokerInfoForClient.totalBet),
                CurrencyDenominator.ToMain(rawServerResponse.videoPokerInfoForClient.totalPotentialWin),
                CurrencyDenominator.ToMain(rawServerResponse.videoPokerInfoForClient.totalWin)),
            rawServerResponse.sessionParam);
    }

    private deserializeCardsArray(rawCardsArray: Array<any>): Array<Card> {
        const cards: Array<Card> = [];
        for (let i = 0; i < rawCardsArray.length; i++) {
            cards.push(CardFactory.createCard(rawCardsArray[i].color, rawCardsArray[i].name));
        }
        return cards;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/ApiService.ts